import { Box, Button } from '@mui/material';

import { CissTextField } from 'components/fields';
import { ChangeStoreGrid } from 'components/header/menu-system/change-store/ChangeStoreGrid';
import { ChangeStoreShellProps } from 'components/header/menu-system/change-store/useChangeStore';
import { ContentModal } from 'components/modal';
import { SubTitle } from 'components/text';

export function ChangeStoreDesktop({ open, setOpen, query, setQuery, selectedStore, setSelectedStore, onClickConfirm }: ChangeStoreShellProps) {
    return (
        <ContentModal
            open={open}
            setOpen={setOpen}
            closeButton
            centered={false}
            sx={{
                maxWidth: 960,
                width: '90vw',
                display: 'flex',
                flexDirection: 'column',
                borderRadius: 1,
            }}
        >
            <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>
                <SubTitle label="Trocar empresa" />

                <CissTextField
                    size="small"
                    label="Pesquisar"
                    placeholder="Nome empresa..."
                    deboundTime={500}
                    sx={{ mb: 2, width: '50%', flexShrink: 0 }}
                    onChange={(e) => setQuery(e.target.value)}
                />

                <Box sx={{ height: 'clamp(200px, calc(80vh - 180px), 600px)' }}>
                    <ChangeStoreGrid query={query} selectedStore={selectedStore} setSelectedStore={setSelectedStore} />
                </Box>

                <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 2, flexShrink: 0 }}>
                    <Button variant="outlined" onClick={() => setOpen(false)}>
                        Cancelar
                    </Button>

                    <Button variant="contained" onClick={onClickConfirm} disabled={!selectedStore}>
                        Confirmar
                    </Button>
                </Box>
            </Box>
        </ContentModal>
    );
}
